import { PeopleRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

export interface PullContactInfoResponse {
  // "complete" when everyone selected was already ours: the free promotions are written
  // synchronously, so there is no operation to poll. "pending" whenever any selected
  // person still needs a paid Apollo lookup.
  status: "pending" | "complete";
  operationKey?: string;
  siteId: string;
  // True when an identical pull was already in flight for this (lead, role) and we
  // coalesced onto it rather than spawning a second one.
  deduped?: boolean;
  // How the selection split: promoted for free from an address HubSpot already held,
  // skipped because they are opted out, and charged to Apollo.
  promotedFromHubSpot?: number;
  blocked?: number;
  chargeable?: number;
}

// Promote the operator's selected people into the contact list. The BE splits the
// selection: anyone HubSpot already holds a usable address for is promoted for free and
// synchronously, and only the remainder becomes a paid Apollo enrichment LRO. `apolloIds` are the
// ticked people from the ranked OR the AI-excluded list. Returns {operationKey,
// siteId} immediately; the worker reveals each person's email + LinkedIn + title,
// skipping any id already pulled (no re-charge), and writes the results onto the
// lead's contactEnrichments[role]. The FE polls useOperation(...) until terminal,
// then refetches the lead to show the pulled contacts.
const postLeadPullContactInfo = async (
  authToken: string,
  leadId: string,
  role: PeopleRole,
  apolloIds: string[]
): Promise<PullContactInfoResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/pull-contact-info`,
    { role, apolloIds },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadPullContactInfo;
